var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 41,
    height: 41,
    rx: 19.0141,
    fill: "#F4A51D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5462 12.498C14.0343 12.498 11.998 14.5343 11.998 17.0462V24.9561C11.998 27.468 14.0343 29.5043 16.5462 29.5043H24.4561C26.968 29.5043 29.0043 27.468 29.0043 24.9561V17.0462C29.0043 14.5343 26.968 12.498 24.4561 12.498H16.5462Z",
    fill: "#F4A51D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3359 24.9551L17.3359 22.5821",
    stroke: "white",
    strokeWidth: 1.18648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.9551L20.5 17.0452",
    stroke: "white",
    strokeWidth: 1.18648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6641 24.9551L23.6641 19.4182",
    stroke: "white",
    strokeWidth: 1.18648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingFilled);
export default __webpack_public_path__ + "static/media/staking-filled.3a81393a736855f0dbbe802a27da8523.svg";
export { ForwardRef as ReactComponent };